import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AspectRationFormatTree, StepperModel, AnnotationStatusEmailTree } from '@thehubz/client/core';
import { SendReminderInformation } from '@thehubz/client/data-access-api';
import { AnyType } from '@thehubz/shared/model';
import { MatSelectSearchComponent } from '../mat-select-search/mat-select-search.component';

@Component({
  selector: 'sp-send-reminder',
  templateUrl: './send-reminder.component.html',
  styleUrls: ['./send-reminder.component.scss'],
})
export class SendReminderComponent implements OnInit {
  @ViewChild(MatSelectSearchComponent) matSelectSearchComp?: MatSelectSearchComponent;
  isMatTreeSelected = false;
  initialStepper!: StepperModel;
  stepperFormGroups: UntypedFormGroup;
  matTreeRawData: AnnotationStatusEmailTree[] = [];
  matTreeData: AnyType = [];

  constructor(
    private _formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<SendReminderComponent>,
    @Inject(MAT_DIALOG_DATA)
    public stepperModel: {
      stepperData: StepperModel;
      annotationData?: AnyType[];
    },
  ) {
    this.stepperFormGroups = this._formBuilder.group({
      description: [
        `<p>Hello,</p><p>We would like to remind you about the pending task requires your attention. Please make a comment at your earliest convenience.</p><p>Thank you!</p>`,
        [Validators.required, Validators.minLength(3)],
      ],
    });
  }

  ngOnInit(): void {
    this.matTreeData = this.stepperModel.annotationData;
    this.initialStepper = JSON.parse(JSON.stringify(this.stepperModel.stepperData));
  }

  closeModal() {
    this.dialogRef.close();
  }

  selectedFormatList(event: AspectRationFormatTree[]) {
    this.matTreeRawData = event;
    if (this.matTreeRawData.length) this.isMatTreeSelected = false;
  }

  sendReminder() {
    const formData = this.stepperFormGroups.getRawValue();
    const reminderData: SendReminderInformation = {
      description: '',
      userData: [],
    };
    if (this.matTreeRawData.length > 0) {
      this.matTreeRawData.forEach((status: AnnotationStatusEmailTree) => {
        if (status.children && status.children.length > 0) {
          status.children.forEach((emailData: AnnotationStatusEmailTree) => {
            if (emailData.selected) {
              const userInfo = {
                email: emailData.name,
                sharedId: emailData.sharedId,
              };
              if (reminderData.userData) {
                reminderData.userData.push(userInfo);
              }
            }
          });
        }
      });
    }
    if (reminderData.userData && reminderData.userData.length > 0) {
      if (formData.description) {
        reminderData.description = formData.description;
      }
      this.dialogRef.close({ reminderData: reminderData });
    } else {
      this.isMatTreeSelected = true;
    }
  }
}
